<script>
	import { Router, Route, Link, navigate } from "svelte-navigator";
	import StartPage from 'components/pages/StartPage.svelte';
	import UAParser from "ua-parser-js";
	import { Dialog, Button } from "smelte";
	import { currentBrowser } from "store";
	import AboutPage from 'components/pages/AboutPage.svelte';
	import NotAvailablePage from 'components/pages/NotAvailablePage.svelte';
	import ConceptReport from 'components/ConceptReport.svelte';
	import AdrTool from 'components/AdrTool.svelte';
	import Generator from 'components/Generator.svelte';
	import LicensePlate from 'components/LicensePlate.svelte';
	import PhotoToolbox from 'components/PhotoToolbox.svelte';

	let showDialog = false;
	function displayBrowserWarning() {
		let parser = new UAParser();
		let detectedBrowser = parser.getBrowser().name
			.toLowerCase()
      .normalize("NFD")
      .replace(/ /g, "")
      .replace(/[^\w\s]/gi, "")
      .replace(/[\u0300-\u036f]/g, "");
		if (detectedBrowser === "chromewebview") {
			// badbrowser (secureweb is) chromewebview
			showDialog = true;
		} else {
			// goodbrowser samsungbrowser / chrome / androidbrowser / firefox
			showDialog = false;
		}
		currentBrowser.set(detectedBrowser);
		return showDialog;
	}
	displayBrowserWarning();

</script>

<Router>
	<header>
		<nav class="bg-blue-900 shadow-lg">
			<div class="container mx-auto">
				<div class="flex">
					<a href="/" class="text-white font-bold p-2">BlueToolkit</a>
	
					<!-- Menus -->
					<div class="ml-55 mt-2">
						<ul class="text-white sm:self-center">
							<li class="inline">
								<Link to="/">Start</Link>
							</li>
							<li class="inline">
								<Link to="over">Over</Link>
							</li>
						</ul>
					</div>
		
				</div>
			</div>
		</nav>
	</header>

	<main>
		<Dialog bind:value={showDialog}>
			<h5 slot="title">Browser niet ondersteund</h5>
			<div class="text-gray-700">
				<p>
					Let op: Je gebruikt een browser die <b>NIET</b> met alle functies van BlueToolkit kan omgaan (oa. PDF download).
				</p>
				<p>
					&nbsp;
				</p>
				<p>Gebruik <b>Google Chrome</b> (Desktop) of <b>Samsung Internet/DuckDuckGo</b> (MEOS) voor het beste resultaat.</p>
			</div>
			<div slot="actions">
				<Button text on:click={() => showDialog = false}>OK, prima</Button>
				<Button text on:click={() => showDialog = false} on:click={() => navigate('/over')}>Meer info</Button>
			</div>
		</Dialog>	
		<Route path="over" component={AboutPage} />
		<Route path="conceptpv" component={ConceptReport} />
		<Route path="adr" component={AdrTool} />
		<Route path="kentekens" component={LicensePlate} />
		<Route path="generator" component={Generator} />
		<Route path="dyco" component={NotAvailablePage} />
		<Route path="verkeershufter" component={NotAvailablePage} />
		<Route path="fotos" component={PhotoToolbox} />
		<Route path="/" component={StartPage} />
		<Route>
			<div class="mx-2">
				<h1 class="text-xl mb-2 font-bold">
					Pagina niet gevonden
				</h1>
				<p>Deze pagina kon niet worden gevonden. Tikfout? Ga terug naar <Link to="/">de homepage</Link>.</p>
			</div>
		</Route>
	</main>
</Router>

<style global lang="postcss">
  @tailwind base;
  @tailwind components;

	:global(h1):focus {
		outline: none;
	}
</style>